import storage from '@/utils/localStorage'
import { isObject, isPrevDays } from '@/utils/utils'

/**
 * 是否展示红包兑换提醒
 * @param {string} key
 */
export const showRemindModal = key => {
  const ca = storage.getItem(key)
  if (!isObject(ca)) {
    storage.setItem(key, {
      date: new Date().getTime(),
      count: 1,
    })
    return true
  }
  const { date, count } = ca
  console.log(isPrevDays(new Date().getTime(), date))
  //已经显示过两次 或则 不是第二天 都不展示
  if (count > 1 || !isPrevDays(new Date().getTime(), date)) return false
  storage.setItem(key, {
    date: new Date().getTime(),
    count: count + 1,
  })
  return true
}
